/**
 * Application error definition
 *
 * @export
 * @class AppError
 * @extends {Error}
 */
export class AppError extends Error {

  /**
   * Whether it is handled by error service or not.
   */
  isHandle = false;

  /**
   * Url of the page that causes the error.
   */
  url?: string;

  /**
   * Inner error.
   */
  error: any;

  constructor(error?: string | Error) {
    super(error instanceof Error ? error.toString() : error);
    this.error = error;
  }
}
